import { Link } from "react-router-dom";
import { useGetSettingQuery } from "../../../../Redux/Apis/siteApi";
import { fa_number } from "../../../../utils/PersianNum";

function Banner() {
    const {data : {home: {banner : {data}}}} = useGetSettingQuery()

    return ( 
        <section className="shop-banner" style={{backgroundImage: `url(${data.img_banner})`}}>
            <div className="container">
                <h3>{data.txt_line1}</h3>
                <h3><span className="orange-text">{data.txt_line2.split(" ")[0]}</span> {data.txt_line2.split(" ").slice(1).join(" ")}</h3>
                <div className="sale-percent"><span> تا</span> {fa_number(data.num_offPercent)}٪ <span>تخفیف بیشتر</span></div>
                <Link to="/shop" className="cart-btn btn-lg">همین الان خرید کنید</Link>
            </div>
        </section>
     );
}

export default Banner;